// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__203aE","fileBtn":"File_fileBtn__s9z7u","closeBtn":"File_closeBtn__6Qixs","fileSelected":"File_fileSelected__1NfMq","disabled":"File_disabled__3Mhk1"};